import { autoinject, computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { EventHelper } from 'framework/aurelia_tools/event-helper';
import { City } from 'model/business-keywords';
import { CitySegment } from 'model/forms/trip-details';
import { LookupsService } from 'services/lookups-service';
import { WidgetBase } from 'support/base_classes/widget-base';
import { ApplicationMessage } from 'support/messaging';
import { MAX_DATE } from 'support/settings';

@autoinject
export class CitySegmentWidget extends WidgetBase<CitySegment, WidgetController> {
  public today = new Date().toISOString().slice(0, 10);
  public maxDate = MAX_DATE.toISOString().slice(0, 10);

  constructor(private lookups: LookupsService, private eventHelper: EventHelper) {
    super();
  }

  bind() {
    ValidationRules
      .ensureObject<CitySegment>().required()
      .ensure(model => model.city).displayName('City of stay').required()
      .ensure(model => model.arrivalDate).displayName('Arrival date').required().satisfiesRule('minDate').satisfiesRule('maxDate')
      .ensure(model => model.departureDate).displayName('Departure date').required().satisfiesRule('minDate').satisfiesRule('maxDate')
      .on(this.model);
  }

  @computedFrom('model.city.country.formFlag')
  get widgetIcon() {
    return this.model.city?.country.formFlag ?? 'fas fa-map-marker-alt';
  }

  @computedFrom('model.city.country.name', 'model.country.name')
  get countryName() {
    return this.model.city?.country.name ?? this.model.country?.name ?? null;
  }

  citiesLookupOptions = this.lookups.getCitiesLookupOptions();

  @watch((x: CitySegmentWidget) => x.model.city)
  private cityChanged(newValue: City, oldValue: City) {
    if (newValue != null) this.model.country = newValue.country;
    this.eventHelper.publish(new CityChanged(this, this.model, newValue, oldValue));
  }
}

export class CityChanged extends ApplicationMessage<CitySegmentWidget> {
  constructor(sender: CitySegmentWidget, public segment: CitySegment, public newValue: City, public oldValue: City) {
    super(sender);
  }
}
